import { formattedPriceFromCents as formatCents } from "@/util/formatter";

/**
 * Formats a price stored in cents to a human-readable dollar string, or an em-dash when absent.
 * e.g. 150000 → "$1,500.00", undefined → "—"
 */
export const formattedPriceFromCents = (cents: number | undefined): string =>
  cents == null ? "—" : formatCents(cents);

/**
 * Converts a price stored in cents to a dollar amount for editable form inputs,
 * preserving `undefined` so an empty field stays empty rather than showing 0.
 * e.g. 150000 → 1500, undefined → undefined
 */
export const centsToDollars = (cents: number | null | undefined): number | undefined =>
  cents != null ? cents / 100 : undefined;
